export default __webpack_public_path__ + "static/media/Kaizen.204ed78c.png";